<script>
import Vue from 'vue'
let GuiTools = new Vue({
  name: 'GuiTools',
  created() {
    console.log("GuiTools created")
  },
  methods: {
    async toast(txt, params) {
      txt = txt || ''
      params = params || {}
      let aC = document.querySelector('ion-alert-controller')
      await aC.componentOnReady()
      let alertObject = {
        header: 'Aviso',
        message: txt,
        buttons: ['Entendido']
      }
      for (let param in params)
        if (params[param])
          alertObject[param] = params[param]
      const alert = await aC.create(alertObject)
      return await alert.present()
    },
    async actionSheet(params, header) {
      header = header || 'Opciones'
      params = params || []
      let aSC = document.querySelector('ion-action-sheet-controller')
      await aSC.componentOnReady()
      params.push({
        text: 'Cancelar',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log("Action Sheet closed by User")
        }
      })
      let actionSheet = await aSC.create({
        header: header,
        buttons: params
      })
      await actionSheet.present()
    }
  }
})
export default GuiTools
</script>
